import { ChangeDetectorRef, Component, ContentChildren, EventEmitter, Input, Output, QueryList, forwardRef, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { SelectItemComponent } from './select-item/select-item.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { InputErrorComponent } from '@atoms/input-error/input-error.component';
import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-select',
  imports: [NgClass, FormsModule, IconComponent, InputErrorComponent],
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
})
export class SelectComponent implements ControlValueAccessor {
  private cd = inject(ChangeDetectorRef);
  private ssrService = inject(SsrService);
  @Input() label?: string;
  @Input() icon?: string;
  @Input() id?: string;
  @Input() required: boolean = false;
  @Input() arrow: boolean = true;
  @Input() error: boolean = false;
  @Input('error-message') errorMessage?: string;
  @Input() value?: string | number;
  @Input() name: string = 'select';
  @Input() align: 'left' | 'center' | 'right' = 'left';
  @Input() size: 'small' | 'medium' = 'medium';
  @Output() valueChange: EventEmitter<string | number> = new EventEmitter<string | number>();
  @ContentChildren(SelectItemComponent) items?: QueryList<SelectItemComponent>;
  public valid?: boolean;
  public lastValue: any;
  public loaded: boolean = false;
  public onChange = (value: string | number) => {};
  public onTouched = (value: boolean) => {};

  change(): void {
    if (!this.value) {
      if (this.required) this.valid = false;
      return;
    } else {
      this.valid = true;
    }
    this.valueChange.emit(this.value);
    this.onChange(this.value);
    this.onTouched(true);
  }

  touch(): void {
    this.onTouched(true);
  }

  ngAfterViewInit(): void {
    if (this.ssrService.isBrowser()) {
      const notFoundContent = this.items?.filter((item) => !item.content);
      if (notFoundContent?.length) {
        setTimeout(() => {
          this.items?.forEach((item) => {
            if (!item.content) item.content = item.item?.nativeElement.innerHTML;
          });
          this.loaded = true;
          this.cd.detectChanges();
        }, 100);
      } else {
        this.loaded = true;
        this.cd.detectChanges();
      }
    } else {
      this.loaded = true;
      this.cd.detectChanges();
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: (value: string | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }
}
